<template>
  <BContainer :title="$t('title.reportCompanyAnswerCompare')">
    <CompanyFilter @apply="getQuestionAndAnswers">
      <template v-slot:customButtons>
        <DownloadExcel
          v-if="isExportButtonActive"
          :data="tableData"
          :fields="excelFields"
          :name="`${title}.xls`"
        >
          <button class="button is-link">{{ $t('button.export') }}</button>
        </DownloadExcel>
      </template>
    </CompanyFilter>
    <section
      class="section b-portlet has-background-light"
      v-if="tableData && tableData.length > 0"
    >
      <b-table
        :data="tableData"
        :bordered="true"
        :striped="true"
        :hoverable="true"
        :mobile-cards="true"
        v-if="tableData.length > 0"
      >
        <template slot-scope="props">
          <b-table-column field="no" label="No" width="40" numeric>{{
            props.row.no
          }}</b-table-column>
          <b-table-column field="name" :label="$t('title.question')">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column
            v-for="user in users"
            :key="user.id"
            :field="user.id"
            :label="user.company.name"
          >
            <b-tag
              v-if="props.row[user.id]"
              :type="props.row[user.id] === $t('button.yes') ? 'is-success' : 'is-danger'"
              >{{ props.row[user.id] }}</b-tag
            >
          </b-table-column>
        </template>
      </b-table>
    </section>
  </BContainer>
</template>
<script>
import ApiService from '../../_api/api.service'
import CompanyFilter from './CompanyFilter.vue'

export default {
  components: { CompanyFilter },
  data() {
    return {
      tableData: [],
      title: 'report-data',
      excelFields: {},
      excelData: [],
      isExportButtonActive: false,
      users: []
    }
  },
  mounted() {
    this.excelFields = this.getExcelFields()
  },
  methods: {
    getQuestionAndAnswers(filter) {
      const { processId, users } = filter
      this.users = users
      const userIds = users.map(cu => cu.id)
      this.score = null
      ApiService.post('/user/answersets', { processId, userIds }).then(data => {
        this.isExportButtonActive = true
        this.generateTableData(data)
      })
    },
    generateTableData(apiData) {
      const questionData = {}
      apiData.questions.forEach(q => {
        questionData[q.id] = { no: q.no, name: q.name }
      })
      apiData.answers.forEach(answer => {
        questionData[answer.question_id][answer.user_id] =
          answer.answer === true ? this.$t('button.yes') : this.$t('button.no')
      })
      this.tableData = Object.keys(questionData).map(key => {
        const row = questionData[key]
        return row
      })
    },
    getExcelFields() {
      const fields = {}
      fields[this.$t('validation.attributes.no')] = 'no'
      fields[this.$t('validation.attributes.question')] = 'name'
      return fields
    }
  }
}
</script>
